
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/lamella",
      function () {
        return require("private-next-pages/rollers/lamella/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/lamella"])
      });
    }
  